export const DEFAULT_LANG = "en";
export const EN_LANG = "en";
export const DE_LANG = "de";
export const PL_LANG = "pl";
export const ZH_LANG = "zh";
export const LANG = "oss_lang";